<template>
  <div>
    <div class="customform-head">
      <div class="text-center customform-head-text"></div>
    </div>
    <div
      class="px-4 pt-3"
      style="font-size: 18px; background-color: #344e76; color: white"
    ></div>
    <div
      class="mt-3"
      style="max-width: 500px; margin-left: auto; margin-right: auto"
    >
      <div
        class="text-center pt-6"
        style="font-size: 25px; font-weight: 900; color: grey"
      >
        <div class="mb-3">
          <v-icon color="grey" size="60">mdi-alert-circle-outline</v-icon>
        </div>
        แบบฟอร์มนี้ <br />ไม่สามารถใช้งานได้
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>